export default "__VITE_ASSET__CoCriNYk__"